import { Component, OnInit } from '@angular/core';
import { RoleRequest } from '../../api/models/role-assignment-map';
import { AuthService } from '../../api/services/auth.service';
import { NavigationButtonService } from '../navigation-button/navigation-button.service';
import { ManagementButtonsService } from './management-buttons.service';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss'],
  providers: [{provide: NavigationButtonService, useClass: ManagementButtonsService}]
})
export class ManagementComponent implements OnInit {

  isTesscoAdmin: boolean = false;
  canEditMarket: boolean = false;
  constructor(private authService: AuthService) { }

  ngOnInit() {
    let roleRequest = new RoleRequest('ADMIN_TESSCO', null);
    roleRequest.setRoleAndContextMap('ORGANIZATION_UPDATE', null);
        this.authService.getUserRoles(roleRequest).subscribe(roles => {
          this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
          
          // We can use this variable if we want to hide market tab
          this.canEditMarket = roles.getRoleMap('ORGANIZATION_UPDATE');
        });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/management.component.ts